// Bits shared between the admin overview (stats) and users pages.

// Badge colors reuse the admin pages' existing status conventions (green =
// good, red = needs attention); the label always carries the meaning, never
// the color alone.
export const SUBSCRIPTION_BADGES: Record<string, { color: string; label: string }> = {
  trial: { color: 'blue', label: 'Trial' },
  active: { color: 'green', label: 'Active' },
  canceled: { color: 'gray', label: 'Canceled' },
  past_due: { color: 'red', label: 'Past due' },
};

// Badges truncate long labels with an ellipsis by default (fixed height,
// nowrap). For informational badges that carry dates or free-text reasons,
// let the label wrap onto multiple lines instead.
export const WRAP_BADGE_STYLES = {
  root: { height: 'auto', paddingTop: 3, paddingBottom: 3 },
  label: {
    whiteSpace: 'normal' as const,
    overflow: 'visible',
    textOverflow: 'clip',
  },
};
